const AppImage = ({ className, ...rest }) => {
    return <img className={`image-style ${className}`} {...rest} />
};

export default AppImage;

